import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CeContainerComponent, CeEmptyStateImports } from '@kempower-nx-workspace/shared/kp-design-system';
import { environment } from '@kempower-nx-workspace/ce-environment';

@Component({
    selector: 'ce-core-empty-state-404',
    imports: [CommonModule, CeEmptyStateImports, CeContainerComponent],
    templateUrl: './empty-state-404.component.html',
    styleUrl: './empty-state-404.component.scss'
})
export class EmptyState404Component {
    emptyStateHref = `https://${environment.appConfig.apiBaseUrl}`;
}
